import { Challenge } from '../models';
import { ChallengeRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class DeclineChallengeUseCase {
  constructor(private challengeRepository: ChallengeRepository) {}

  async execute(challengeId: string): Promise<Challenge> {
    logger.debug('DeclineChallenge', 'Declining challenge', { challengeId });

    const challenge = await this.challengeRepository.declineChallenge(challengeId);

    logger.debug('DeclineChallenge', 'Challenge declined successfully');

    return challenge;
  }
}
